import {documentToHtmlString} from "@contentful/rich-text-html-renderer"

const getTextFromHTML = (input: string | undefined | null) => {
    if (!input) return ""
    let result = documentToHtmlString(JSON.parse(input))
    result = result.replaceAll(/<[^<>]+>/gm, "")
    return result
}

export default getTextFromHTML
